import { useSearchParams } from "react-router-dom";
import { useState } from "react";

const Register = () => {
  const [params] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);

  const title = params.get("title") || "";
  const date = params.get("date") || "";
  const location = params.get("location") || "";
  const price = params.get("price") || "";

  const handleCheckout = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const form = e.target;

    const payload = {
      name: form.name.value,
      email: form.email.value,
      phone: form.phone.value,
      courseTitle: title,
      courseDate: date,
      courseLocation: location,
      coursePrice: price,
    };

    try {
      const res = await fetch("/api/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const { url } = await res.json();
      window.location.href = url;
    } catch (err) {
      console.error("Stripe checkout failed:", err);
      alert("❌ Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="pt-32 px-4 pb-20 bg-white text-gray-900 font-sans">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-blue-900 text-center">Register for: {title}</h1>
        <div className="mb-6 text-sm text-gray-700 text-center">
          <p><strong>Date:</strong> {date}</p>
          <p><strong>Location:</strong> {location}</p>
          <p><strong>Price:</strong> ${price}</p>
        </div>
        <form onSubmit={handleCheckout} className="space-y-4 bg-gray-50 p-8 shadow-lg rounded-xl">
          <input type="text" name="name" placeholder="Full Name" className="w-full p-3 border rounded-md" required />
          <input type="email" name="email" placeholder="Email" className="w-full p-3 border rounded-md" required />
          <input type="tel" name="phone" placeholder="Phone (10 digits)" className="w-full p-3 border rounded-md" required />

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-green-600 text-white py-3 rounded-md font-semibold hover:bg-green-500 transition"
          >
            {submitting ? "Redirecting..." : "Continue to Payment"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Register;
